import React, { useState, useEffect } from "react";
import "./PurchasePopup.scss";
import { IoClose } from "react-icons/io5";

const PurchasePopup = ({ isOpen, onClose, itemDetails, onProceed, loggedInUser }) => {
	const [userDetails, setUserDetails] = useState({
		name: loggedInUser?.firstName + " " + loggedInUser?.lastName || "",
		email: loggedInUser?.email || "",
		mobile: loggedInUser?.phoneNumber?.replace(/^\+91/, "") || "",
	});

	const [isFormValid, setIsFormValid] = useState(false);

	useEffect(() => {
		console.log(loggedInUser);
		const isValid =
			userDetails.name.trim() !== "" &&
			userDetails.email.trim() !== "" &&
			/^[0-9]{10}$/.test(userDetails.mobile);

		setIsFormValid(isValid);
	}, [userDetails]);

	const handleChange = (e) => {
		const { name, value } = e.target;
		setUserDetails((prev) => ({
			...prev,
			[name]: value,
		}));
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		onProceed(userDetails);
	};

	if (!isOpen) return null;

	const renderItemDetails = () => {
		switch (itemDetails.type) {
			case "meeting":
				return (
					<div className="details-grid">
						<div className="detail-item">
							<span className="label">Meeting:</span>
							<span className="value">{itemDetails.name}</span>
						</div>

						<div className="detail-item">
							<span className="label">Description:</span>
							<span className="value" dangerouslySetInnerHTML={{ __html: itemDetails.description }} />
						</div>

						<div className="detail-item">
							<span className="label">Selected Slot:</span>
							<span className="value">
								{new Date(itemDetails?.selectedSlot?.date).toLocaleDateString('en-US', {
									weekday: 'long',
									year: 'numeric',
									month: 'long',
									day: 'numeric'
								})}
								<br />
								{itemDetails?.selectedSlot?.time}
							</span>
						</div>

						<div className="detail-item-footer">
							<div className="detail-item">
								<span className="label">Duration:</span>
								<span className="value">{itemDetails?.duration} minutes</span>
							</div>

							<div className="detail-item">
								<span className="label">Price:</span>
								<span className="value">
									{itemDetails?.is_free ? "Free" : `₹${itemDetails?.amount}`}
								</span>
							</div>
						</div>
					</div>
				);

			case "priorityDM":
				return (
					<div className="details-grid">
						<div className="detail-item">
							<span className="label">Service:</span>
							<span className="value">{itemDetails?.name}</span>
						</div>

						<div className="detail-item">
							<span className="label">Description:</span>
							<span className="value">{itemDetails?.description}</span>
						</div>

						<div className="detail-item-footer">
							<div className="detail-item">
								<span className="label">Type:</span>
								<span className="value">Priority DM</span>
							</div>

							<div className="detail-item">
								<span className="label">Price:</span>
								<span className="value">
									{itemDetails?.is_free ? "Free" : `₹${itemDetails?.amount}`}
								</span>
							</div>
						</div>
					</div>
				);

			case "community":
				return (
					<div className="details-grid">
						<div className="detail-item">
							<span className="label">Name:</span>
							<span className="value">{itemDetails?.name}</span>
						</div>

						<div className="detail-item">
							<span className="label">Description:</span>
							<span className="value" dangerouslySetInnerHTML={{ __html: itemDetails?.description }} />
						</div>

						<div className="detail-item-footer">
							<div className="detail-item">
								<span className="label">Member Count:</span>
								<span className="value">{itemDetails?.memberCount}</span>
							</div>

							<div className="detail-item">
								<span className="label">Price:</span>
								<span className="value">
									{itemDetails.is_free ? "Free" : `₹${itemDetails?.amount}`}
								</span>
							</div>
						</div>
					</div>
				);
			default:
				return (
					<div className="details-grid">
						<div className="detail-item">
							<span className="label">Name:</span>
							<span className="value">{itemDetails?.name}</span>
						</div>

						<div className="detail-item">
							<span className="label">Description:</span>
							<span className="value" dangerouslySetInnerHTML={{ __html: itemDetails?.description }} />
						</div>
						<div className="detail-item-footer">
							<div className="detail-item">
								<span className="label">Resources:</span>
								<span className="value">
									{itemDetails?.resourceCount || 0} files
								</span>
							</div>

							<div className="detail-item">
								<span className="label">Access:</span>
								<span className="value">Lifetime</span>
							</div>

							<div className="detail-item">
								<span className="label">Price:</span>
								<span className="value">
									{itemDetails?.is_free ? "Free" : `₹${itemDetails?.amount}`}
								</span>
							</div>
						</div>
					</div>
				);
		}
	};

	return (
		<div className="purchase-modal-overlay">
			<div className="purchase-modal-content">
				<div className="purchase-modal-left">
					<div className="purchase-modal-header">
						<div className="header-with-close">
							<h2>{itemDetails.type === "priorityDM" ? "Ask a Question" : itemDetails?.type === "meeting" ? "Book a Meeting" : itemDetails?.type === "community" ? "Join Community" : "Purchase Product"}</h2>
							<button className="close-button" onClick={onClose}>
								<IoClose size={24} />
							</button>
						</div>
						<p className="subtitle">
							Please fill these details for purchase confirmation and further
							communication.
						</p>
					</div>

					<form onSubmit={handleSubmit} className="purchase-form">
						<div className="form-group">
							<label htmlFor="name">Name</label>
							<input
								type="text"
								id="name"
								name="name"
								value={userDetails?.name}
								onChange={handleChange}
								required
								placeholder="Enter Name"
							/>
						</div>

						<div className="form-group">
							<label htmlFor="email">Email</label>
							<input
								type="email"
								id="email"
								name="email"
								value={userDetails?.email}
								onChange={handleChange}
								required
								placeholder="Enter Email"
							/>
						</div>

						<div className="form-group">
							<label htmlFor="mobile">Mobile Number</label>
							<input
								type="tel"
								id="mobile"
								name="mobile"
								value={userDetails?.mobile}
								onChange={handleChange}
								required
								pattern="[0-9]{10}"
								placeholder="Enter Mobile Number"
							/>
						</div>

						<div className="modal-actions">
							<button type="button" className="cancel-btn" onClick={onClose}>
								Cancel
							</button>
							<button
								type="submit"
								className={`proceed-btn ${!isFormValid ? "disabled" : ""}`}
								disabled={!isFormValid}
							>
								{itemDetails.is_free ? "Join Now" : "Proceed to Payment"}
							</button>
						</div>
					</form>
				</div>

				<div className="purchase-modal-right">
					<div className="item-details-card">
						<div className="card-header">
							<h3>Details</h3>
						</div>
						{renderItemDetails()}
					</div>
				</div>
			</div>
		</div>
	);
};

export default PurchasePopup;
